module.exports = __webpack_public_path__ + "static/media/img_picture_collage.de4b22b9.png";